import PageLoadedQueue from "../../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";
import {Toast, Tooltip} from "bootstrap";

/**
 * Class to handle the keyword update form
 */
export class KeywordForm {
    protected form: HTMLFormElement;
    protected submitButton: HTMLButtonElement;
    protected successToastElement: HTMLElement;
    protected failedColumn: HTMLElement;

    constructor() {
        this.form = document.getElementById('solutions-experts-profile-edit-keyword-form') as HTMLFormElement;
        this.submitButton = document.getElementById('update-form-profile-keywords--submit-button') as HTMLButtonElement;
        this.successToastElement = document.getElementById('update-form-profile-keywords-toast-success') as HTMLElement;
        this.failedColumn = document.getElementById('update-form-profile-keywords-column-failure') as HTMLElement;

        if (
            !this.submitButton
            || !this.form
            || !this.successToastElement
            || !this.failedColumn
        ) {
            return;
        }

        document.body.append(this.successToastElement);

        this.updateKeywordsOnSubmit();
    }

    /**
     * Send the keywords to the server
     */
    protected updateKeywordsOnSubmit = () => {
        this.form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const formData = new FormData(this.form);

            const response = await fetch(this.form.action, {
                method: 'POST',
                body: formData
            })
                .then((response) => {
                    // reset message elements
                    this.failedColumn?.classList.add('d-none');
                    this.successToastElement?.classList.remove('show');

                    return response.json();
                })
                .then((data) => {
                    if (data.success) {
                        if (this.successToastElement) {
                            const toast = Toast.getOrCreateInstance(this.successToastElement);
                            toast.show();
                        }

                        // set the new values as the default values
                        const inputs = this.form.querySelectorAll('input');
                        inputs.forEach((input) => {
                            input.setAttribute('value', input.value);
                        });

                        return;
                    }

                    if (data.message) {
                        this.showFailedText(data.message);
                        return;
                    }

                    throw new Error('unknown error - 1714596383');
                })

                .catch((error) => {
                    this.showFailedText();
                    console.error('Error:', error);
                });
        });
    }

    protected showFailedText = (text: string|null = null) => {
        this.failedColumn.classList.remove('d-none');

        this.failedColumn.querySelector('.alert').textContent = text
            ? text
            : this.failedColumn.dataset.messageErrorOccurred;
    }
}

PageLoadedQueue.addFunction(() => {
    new KeywordForm();
});
